export const environment = {
  production: false,
  apiUrl: 'https://linda-coffee.softsale.kz/'
};
